"use strict";

var _defineProperty2 = require("/home/circleci/project/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");

var _FIELD_COMPONENT_MAP;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _array = require("@widergy/web-utils/lib/array");

var _fieldsHelper = require("../../utils/fieldsHelper");

var FORMS = _interopRequireWildcard(require("../../constants/fieldTypes"));

var _formTypes = require("../../types/formTypes");

var _Error = _interopRequireDefault(require("./assets/Error"));

var _utils = require("./utils");

var _stylesModule = _interopRequireDefault(require("./styles.module.scss"));

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}
/* eslint-disable react/display-name */


var FIELD_COMPONENT_MAP = (_FIELD_COMPONENT_MAP = {}, _defineProperty2(_FIELD_COMPONENT_MAP, FORMS.FIELD_LABEL, function (FieldComponent, field, input, meta, fieldProps) {
  return /*#__PURE__*/_react.default.createElement(FieldComponent, _extends({
    input: input,
    meta: meta,
    field: field,
    semibold: true
  }, fieldProps), field.title);
}), _defineProperty2(_FIELD_COMPONENT_MAP, FORMS.FIELD_FORM_LINK, function (FieldComponent, field, input, meta, fieldProps) {
  return /*#__PURE__*/_react.default.createElement(FieldComponent, _extends({
    input: input,
    meta: meta,
    field: field,
    description: field.description
  }, fieldProps));
}), _defineProperty2(_FIELD_COMPONENT_MAP, FORMS.FIELD_IMAGE_LABEL, function (_, field, input, meta, fieldProps) {
  return /*#__PURE__*/_react.default.createElement("div", {
    className: _stylesModule.default.imageContainer
  }, /*#__PURE__*/_react.default.createElement("img", _extends({
    input: input,
    meta: meta,
    alt: field.title,
    src: field.description,
    className: _stylesModule.default.imageLabel
  }, fieldProps)));
}), _defineProperty2(_FIELD_COMPONENT_MAP, FORMS.FIELD_URL, function (_, field, input, meta, fieldProps) {
  return /*#__PURE__*/_react.default.createElement("a", _extends({
    input: input,
    meta: meta,
    href: field.description,
    target: "_blank",
    rel: "noopener noreferrer",
    className: _stylesModule.default.url
  }, fieldProps), field.title);
}), _defineProperty2(_FIELD_COMPONENT_MAP, FORMS.FIELD_SWITCH, function (FieldComponent, field, input, meta, fieldProps) {
  return /*#__PURE__*/_react.default.createElement(FieldComponent, _extends({
    input: input,
    meta: meta,
    disabled: field.read_only,
    field: field
  }, fieldProps));
}), _defineProperty2(_FIELD_COMPONENT_MAP, FORMS.FIELD_SELECT, function (FieldComponent, field, input, meta, fieldProps) {
  var visibleOptions = (0, _fieldsHelper.filterVisibleOptions)(field, fieldProps.selectedOptionsIds);
  if (visibleOptions.length === 0) return null;
  return /*#__PURE__*/_react.default.createElement(FieldComponent, _extends({
    field: field,
    input: input,
    meta: meta,
    valueKey: "value",
    labelKey: "name",
    shouldDisplayErrors: false,
    placeholder: field.placeholder || field.title,
    options: visibleOptions,
    disabled: field.read_only,
    withOrder: true,
    tooltip: field.tooltip
  }, fieldProps));
}), _defineProperty2(_FIELD_COMPONENT_MAP, FORMS.FIELD_SKETCH, function (FieldComponent, field, input, meta, fieldProps) {
  return /*#__PURE__*/_react.default.createElement(FieldComponent, _extends({
    field: field,
    input: input,
    meta: meta,
    image: field.image_url,
    disabled: field.read_only,
    childKeys: (0, _utils.parseChildKeys)(field.child_keys)
  }, fieldProps));
}), _defineProperty2(_FIELD_COMPONENT_MAP, FORMS.FIELD_CUIT, function (FieldComponent, field, input, meta, fieldProps) {
  return /*#__PURE__*/_react.default.createElement(FieldComponent, _extends({
    input: input,
    meta: meta,
    disabled: field.read_only,
    field: field
  }, fieldProps));
}), _defineProperty2(_FIELD_COMPONENT_MAP, FORMS.FIELD_IMAGE_RADIO, function (FieldComponent, field, input, meta, fieldProps) {
  var visibleOptions = (0, _fieldsHelper.filterVisibleOptions)(field, fieldProps.selectedOptionIds);

  if (visibleOptions.length === 0) {
    return null;
  }

  return /*#__PURE__*/_react.default.createElement(FieldComponent, _extends({
    field: field,
    input: input,
    meta: meta,
    disabled: field.read_only,
    options: visibleOptions
  }, fieldProps));
}), _defineProperty2(_FIELD_COMPONENT_MAP, FORMS.FIELD_CHIP, function (FieldComponent, field, input, meta, fieldProps) {
  return /*#__PURE__*/_react.default.createElement(FieldComponent, _extends({
    disabled: field.read_only,
    input: input,
    meta: meta,
    title: field.title,
    field: field
  }, fieldProps));
}), _defineProperty2(_FIELD_COMPONENT_MAP, FORMS.FIELD_TEXT, function (FieldComponent, field, input, meta, fieldProps) {
  return /*#__PURE__*/_react.default.createElement(FieldComponent, _extends({
    field: field,
    input: input,
    meta: meta,
    label: field.title,
    placeholder: field.placeholder,
    disabled: field.read_only,
    tooltip: field.tooltip
  }, fieldProps));
}), _defineProperty2(_FIELD_COMPONENT_MAP, FORMS.FIELD_DATE, function (FieldComponent, field, input, meta, fieldProps) {
  return /*#__PURE__*/_react.default.createElement(FieldComponent, _extends({
    field: field,
    input: input,
    meta: meta,
    label: field.title,
    placeholder: field.placeholder,
    disabled: field.read_only
  }, fieldProps));
}), _defineProperty2(_FIELD_COMPONENT_MAP, FORMS.FIELD_EMAIL, function (FieldComponent, field, input, meta, fieldProps) {
  return /*#__PURE__*/_react.default.createElement(FieldComponent, _extends({
    field: field,
    input: input,
    meta: meta,
    label: field.title,
    placeholder: field.placeholder,
    disabled: field.read_only,
    tooltip: field.tooltip
  }, fieldProps));
}), _defineProperty2(_FIELD_COMPONENT_MAP, FORMS.FIELD_PHONE, function (FieldComponent, field, input, meta, fieldProps) {
  return /*#__PURE__*/_react.default.createElement(FieldComponent, _extends({
    field: field,
    input: input,
    meta: meta,
    label: field.title,
    placeholder: field.placeholder,
    disabled: field.read_only,
    childKeys: (0, _utils.parseChildKeys)(field.child_keys)
  }, fieldProps));
}), _defineProperty2(_FIELD_COMPONENT_MAP, FORMS.FIELD_PASSWORD, function (FieldComponent, field, input, meta, fieldProps) {
  return /*#__PURE__*/_react.default.createElement(FieldComponent, _extends({
    field: field,
    input: input,
    meta: meta,
    label: field.title,
    placeholder: field.placeholder,
    disabled: field.read_only,
    tooltip: field.tooltip,
    type: "password"
  }, fieldProps));
}), _defineProperty2(_FIELD_COMPONENT_MAP, FORMS.FIELD_TEXT_AREA, function (FieldComponent, field, input, meta, fieldProps) {
  return /*#__PURE__*/_react.default.createElement(FieldComponent, _extends({
    field: field,
    input: input,
    meta: meta,
    onChange: input.onChange,
    onBlur: input.onBlur,
    onFocus: input.onFocus,
    value: input.value,
    style: _stylesModule.default.textArea,
    disabled: field.read_only,
    placeholder: field.placeholder
  }, fieldProps));
}), _defineProperty2(_FIELD_COMPONENT_MAP, FORMS.FIELD_RATING_STAR, function (FieldComponent, field, input, meta, fieldProps) {
  return /*#__PURE__*/_react.default.createElement(FieldComponent, _extends({
    field: field,
    input: input,
    meta: meta,
    onChange: input.onChange,
    value: input.value,
    stars: field.field_options,
    disabled: field.read_only
  }, fieldProps));
}), _defineProperty2(_FIELD_COMPONENT_MAP, FORMS.FIELD_IMAGE, function (FieldComponent, field, input, meta, fieldProps) {
  return /*#__PURE__*/_react.default.createElement(FieldComponent, _extends({
    field: field,
    input: input,
    meta: meta,
    onChange: input.onChange,
    value: input.value,
    accountId: fieldProps.account && fieldProps.account.id,
    previewStyle: _stylesModule.default.imagePreview,
    inputStyle: _stylesModule.default.imageUploader,
    fieldTypes: ['image'],
    disabled: field.read_only
  }, fieldProps));
}), _defineProperty2(_FIELD_COMPONENT_MAP, FORMS.FIELD_ATTACHMENT, function (FieldComponent, field, input, meta, fieldProps) {
  return /*#__PURE__*/_react.default.createElement(FieldComponent, _extends({
    field: field,
    input: input,
    meta: meta,
    onChange: input.onChange,
    value: input.value,
    accountId: fieldProps.account && fieldProps.account.id,
    previewStyle: _stylesModule.default.imagePreview,
    inputStyle: _stylesModule.default.imageUploader,
    fieldTypes: ['image', 'pdf'],
    disabled: field.read_only
  }, fieldProps));
}), _defineProperty2(_FIELD_COMPONENT_MAP, FORMS.FIELD_PDF, function (FieldComponent, field, input, meta, fieldProps) {
  return /*#__PURE__*/_react.default.createElement(FieldComponent, _extends({
    field: field,
    input: input,
    meta: meta,
    onChange: input.onChange,
    value: input.value,
    accountId: fieldProps.account && fieldProps.account.id,
    inputStyle: _stylesModule.default.imageUploader,
    fieldTypes: ['pdf'],
    disabled: field.read_only
  }, fieldProps));
}), _defineProperty2(_FIELD_COMPONENT_MAP, FORMS.FIELD_RADIO, function (FieldComponent, field, input, meta, fieldProps) {
  var visibleOptions = (0, _fieldsHelper.filterVisibleOptions)(field, fieldProps.selectedOptionIds);

  if (visibleOptions.length === 0) {
    return null;
  }

  var selectedOption = field.field_options.find(function (option) {
    return option.value === input.value;
  });
  return /*#__PURE__*/_react.default.createElement(FieldComponent, _extends({
    field: field,
    input: input,
    meta: meta,
    selectedOptionName: selectedOption && selectedOption.name,
    options: visibleOptions,
    valueKey: "value",
    labelKey: "name",
    disabled: field.read_only
  }, fieldProps));
}), _defineProperty2(_FIELD_COMPONENT_MAP, FORMS.FIELD_MAP, function (FieldComponent, field, input, meta, fieldProps) {
  var account = fieldProps.account,
      defaultCoordinates = fieldProps.defaultCoordinates,
      useGeolocation = fieldProps.useGeolocation;
  var startLocation = {};

  if (account) {
    startLocation.lat = account.latitude && account.latitude !== 0 ? account.latitude : defaultCoordinates && defaultCoordinates.latitude;
    startLocation.lng = account.longitude && account.longitude !== 0 ? account.longitude : defaultCoordinates && defaultCoordinates.longitude;
  } else {
    startLocation.lat = defaultCoordinates && defaultCoordinates.latitude;
    startLocation.lng = defaultCoordinates && defaultCoordinates.longitude;
  }

  var customProps = {};
  if (!(0, _array.isEmpty)(field.child_keys)) customProps.childKeys = (0, _utils.parseChildKeys)(field.child_keys);
  return /*#__PURE__*/_react.default.createElement(FieldComponent, _extends({
    input: input,
    meta: meta,
    field: field,
    placeholder: field.placeholder,
    singleMarker: true,
    disabled: field.read_only,
    useGeolocation: useGeolocation,
    startLocation: {
      position: startLocation,
      key: Date.now(),
      defaultAnimation: 2
    },
    className: _stylesModule.default.fieldMap,
    onChange: input.onChange
  }, customProps, fieldProps));
}), _defineProperty2(_FIELD_COMPONENT_MAP, FORMS.FIELD_CHECKBOX, function (FieldComponent, field, input, meta, fieldProps) {
  return /*#__PURE__*/_react.default.createElement(FieldComponent, _extends({
    field: field,
    label: field.title,
    disabled: field.read_only,
    input: input,
    meta: meta
  }, fieldProps));
}), _defineProperty2(_FIELD_COMPONENT_MAP, FORMS.FIELD_CREDIT_CARD, function (FieldComponent, field, input, meta, fieldProps) {
  return /*#__PURE__*/_react.default.createElement(FieldComponent, _extends({
    field: field,
    input: input,
    meta: meta,
    label: field.title,
    placeholder: field.placeholder,
    disabled: field.read_only,
    tooltip: field.tooltip,
    autoComplete: "off"
  }, fieldProps));
}), _defineProperty2(_FIELD_COMPONENT_MAP, FORMS.FIELD_ANIMATED_CREDIT_CARD, function (FieldComponent, field, input, meta, fieldProps) {
  return /*#__PURE__*/_react.default.createElement(FieldComponent, _extends({
    field: field,
    disabled: field.read_only,
    input: input,
    meta: meta,
    childKeys: (0, _utils.parseChildKeys)(field.child_keys)
  }, fieldProps));
}), _defineProperty2(_FIELD_COMPONENT_MAP, FORMS.FIELD_CAPTCHA, function (FieldComponent, field, input, meta, fieldProps) {
  return /*#__PURE__*/_react.default.createElement(FieldComponent, _extends({
    field: field,
    onChange: input.onChange,
    disabled: field.read_only,
    size: "normal",
    meta: meta
  }, fieldProps));
}), _defineProperty2(_FIELD_COMPONENT_MAP, FORMS.FIELD_CHECKLIST, function (FieldComponent, field, input, meta, fieldProps) {
  return /*#__PURE__*/_react.default.createElement(FieldComponent, _extends({
    field: field,
    input: input,
    meta: meta,
    list: field.field_options,
    shouldDisplayErrors: false,
    labelKey: "name",
    valueKey: "value",
    disabled: field.read_only
  }, fieldProps));
}), _defineProperty2(_FIELD_COMPONENT_MAP, FORMS.FIELD_AUTOCOMPLETE, function (FieldComponent, field, input, meta, fieldProps) {
  return /*#__PURE__*/_react.default.createElement(FieldComponent, _extends({
    field: field,
    disabled: field.read_only,
    placeholder: field.placeholder,
    input: input,
    meta: meta,
    label: field.title,
    options: field.field_options,
    shouldDisplayErrors: false
  }, fieldProps));
}), _defineProperty2(_FIELD_COMPONENT_MAP, FORMS.FIELD_TABLE, function (FieldComponent, field, input, meta, fieldProps) {
  return /*#__PURE__*/_react.default.createElement(FieldComponent, _extends({
    field: field,
    disabled: field.read_only,
    input: input,
    meta: meta
  }, fieldProps));
}), _FIELD_COMPONENT_MAP);
/* eslint-enable react/display-name */

function UTFormField(_ref) {
  var initialField = _ref.field,
      input = _ref.input,
      meta = _ref.meta,
      fieldClasses = _ref.fieldClasses,
      components = _ref.components,
      FeedbackIcon = _ref.FeedbackIcon,
      fieldProps = _ref.fieldProps;
  var Icon = FeedbackIcon || _Error.default;

  var field = _objectSpread({}, initialField, {
    title: (0, _utils.getFieldTitle)(initialField)
  });

  var fieldConstructor = FIELD_COMPONENT_MAP[field.type];
  var FieldComponent = components[field.type];
  var LabelComponent = components[FORMS.FIELD_LABEL];
  if (!fieldConstructor || !FieldComponent && !(0, _utils.useNativeComponent)(field) || !LabelComponent) return null;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(_stylesModule.default.fieldContainer, " ").concat(fieldClasses.container, " ").concat(field.style && _stylesModule.default.textAreaCorrector)
  }, (0, _utils.shouldShowTitle)(field) && /*#__PURE__*/_react.default.createElement(LabelComponent, {
    darkBlue: true,
    className: "".concat(_stylesModule.default.fieldTitle, " ").concat(fieldClasses.title)
  }, field.title), field.comment && /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(_stylesModule.default.comment, " ").concat(fieldClasses.comment)
  }, /*#__PURE__*/_react.default.createElement(Icon, {
    className: "".concat(_stylesModule.default.commentIcon, " ").concat(fieldClasses.commentIcon)
  }), /*#__PURE__*/_react.default.createElement(LabelComponent, {
    className: _stylesModule.default.fieldComment
  }, "".concat(field.comment))), fieldConstructor(FieldComponent, field, input, meta, fieldProps[field.type]), /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(_stylesModule.default.error, " ").concat(fieldClasses.error)
  }, (0, _utils.shouldShowErrors)(meta, field.type) && /*#__PURE__*/_react.default.createElement(LabelComponent, {
    error: true,
    small: true
  }, meta.error)));
}

UTFormField.propTypes = _formTypes.UtFormFieldPropTypes;
var _default = UTFormField;
exports.default = _default;